 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"businessCardEnter":"businessCardEnter","businessCardShare":"businessCardShare","businessCard":"businessCard","material~materialPreview~selfPosterEdit~vSearch~workMaterial":"material~materialPreview~selfPosterEdit~vSearch~workMaterial","material~materialPreview~workMaterial":"material~materialPreview~workMaterial","material":"material","workMaterial":"workMaterial","activity~vSearch":"activity~vSearch","activity":"activity","customerCard":"customerCard","vSearch":"vSearch","cusGroupChatDetail":"cusGroupChatDetail","cusGroupChat":"cusGroupChat","selfPoster":"selfPoster","speechbank":"speechbank","createAndEdit":"createAndEdit","materialPreview":"materialPreview","selfPosterEdit":"selfPosterEdit","message":"message","searchMaterial":"searchMaterial","selfPosterList":"selfPosterList"}[chunkId]||chunkId) + "." + {"businessCardEnter":"f6dce684","businessCardShare":"8d93093e","chunk-05c22c88":"6c03cfff","chunk-0e01cab9":"2d77d2a7","chunk-53626b14":"e9bcbf3d","businessCard":"f4e1de2c","chunk-2405f671":"0f5fef51","chunk-461dcbeb":"ad2b03a8","chunk-b9ebead6":"e66235ed","chunk-3b910dfb":"659a9f27","material~materialPreview~selfPosterEdit~vSearch~workMaterial":"903e13cf","material~materialPreview~workMaterial":"eb2260c3","material":"4a0d2442","workMaterial":"ab622767","chunk-ccb37a0e":"44421899","activity~vSearch":"def452a3","activity":"0a36fa1d","customerCard":"b5bd941e","vSearch":"1953949b","cusGroupChatDetail":"1a0837eb","cusGroupChat":"5f1aece5","selfPoster":"0abfebfa","speechbank":"7a688839","chunk-4e32f204":"a994a846","chunk-57d6362e":"bf5a2c2f","chunk-21ee44d2":"d2a5859a","chunk-358eb2b0":"3b6ca5d8","createAndEdit":"bc525391","materialPreview":"1370af88","selfPosterEdit":"b1112f68","message":"51c1c823","searchMaterial":"84b67004","selfPosterList":"5d38010a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"businessCardEnter":1,"businessCardShare":1,"chunk-05c22c88":1,"chunk-0e01cab9":1,"businessCard":1,"chunk-2405f671":1,"chunk-461dcbeb":1,"chunk-3b910dfb":1,"material":1,"workMaterial":1,"activity~vSearch":1,"activity":1,"customerCard":1,"vSearch":1,"cusGroupChatDetail":1,"cusGroupChat":1,"speechbank":1,"chunk-4e32f204":1,"chunk-57d6362e":1,"chunk-21ee44d2":1,"chunk-358eb2b0":1,"createAndEdit":1,"materialPreview":1,"selfPosterEdit":1,"message":1,"searchMaterial":1,"selfPosterList":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"businessCardEnter":"businessCardEnter","businessCardShare":"businessCardShare","businessCard":"businessCard","material~materialPreview~selfPosterEdit~vSearch~workMaterial":"material~materialPreview~selfPosterEdit~vSearch~workMaterial","material~materialPreview~workMaterial":"material~materialPreview~workMaterial","material":"material","workMaterial":"workMaterial","activity~vSearch":"activity~vSearch","activity":"activity","customerCard":"customerCard","vSearch":"vSearch","cusGroupChatDetail":"cusGroupChatDetail","cusGroupChat":"cusGroupChat","selfPoster":"selfPoster","speechbank":"speechbank","createAndEdit":"createAndEdit","materialPreview":"materialPreview","selfPosterEdit":"selfPosterEdit","message":"message","searchMaterial":"searchMaterial","selfPosterList":"selfPosterList"}[chunkId]||chunkId) + "." + {"businessCardEnter":"f4a725a5","businessCardShare":"c26d9939","chunk-05c22c88":"9e51090e","chunk-0e01cab9":"2ad394e3","chunk-53626b14":"31d6cfe0","businessCard":"68c3e29e","chunk-2405f671":"2b874d67","chunk-461dcbeb":"2fd8c11a","chunk-b9ebead6":"31d6cfe0","chunk-3b910dfb":"d32b7fef","material~materialPreview~selfPosterEdit~vSearch~workMaterial":"31d6cfe0","material~materialPreview~workMaterial":"31d6cfe0","material":"bad1951c","workMaterial":"bbd4fa60","chunk-ccb37a0e":"31d6cfe0","activity~vSearch":"ed0f921c","activity":"467cc5e4","customerCard":"826b8d9b","vSearch":"46f88d4d","cusGroupChatDetail":"635ad64b","cusGroupChat":"b4f4c6f5","selfPoster":"31d6cfe0","speechbank":"1fdb06a0","chunk-4e32f204":"66f23e9a","chunk-57d6362e":"e543da49","chunk-21ee44d2":"8d6b88b5","chunk-358eb2b0":"51faed47","createAndEdit":"8210be1b","materialPreview":"5a14a18b","selfPosterEdit":"d8c267cb","message":"1fa462ea","searchMaterial":"2af3c0d6","selfPosterList":"f7f9bb6a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://wecomop-uat-pub-1329914492.cos.ap-shanghai.myqcloud.com/scrm-h5//";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
